module.exports = __webpack_public_path__ + "static/media/DSC09816.feec0d9e.jpg";